import { ProfileService } from 'client/services';

const loader = async () => {
    const lastSubmittedDate = await ProfileService.getUserFeedbackLog();
    return { lastSubmittedDate };
};

export default loader;
